import { TextField } from "@mui/material"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { observer } from "mobx-react-lite"
import { useStore } from "../../../app/stores/store"

const HomeTrendStartDate = () => {
    const { setSelectedStartDate, selectedStartDate } = useStore().homeTrendChartStore
    
    const handleChange = (e: any) => {
        setSelectedStartDate(e)
    }
    
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
                views={['year', 'month']}
                inputFormat={'MMMM yyyy'}
                disableMaskedInput
                renderInput={(params) => <TextField fullWidth {...params}></TextField>} 
                value={selectedStartDate} 
                onChange={handleChange}
                maxDate={new Date()}
            />
        </LocalizationProvider>
    )
}

export default observer(HomeTrendStartDate)